import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { fetchAuthedBlobUrl, revokeBlobUrl, toProtectedFileUrl } from '../utils/secureFile';
import { openInAppFilePreview } from '../utils/filePreviewBus';

/**
 * <img> untuk file backend ber-auth (fetch blob + cookie).
 */
export default function SecureFileImg({
  src,
  alt = '',
  style,
  className,
  previewTitle,
  onClick,
  enablePreview = true,
  ...rest
}) {
  const [blobUrl, setBlobUrl] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setError(false);
    setBlobUrl('');
    if (!src) return undefined;

    fetchAuthedBlobUrl(src)
      .then((url) => {
        if (!active) return;
        setBlobUrl(url);
      })
      .catch(() => {
        if (active) setError(true);
      });

    return () => {
      active = false;
    };
  }, [src]);

  if (!src) return null;
  if (error) {
    return (
      <span className={className} style={{ ...style, display: 'inline-flex', alignItems: 'center', color: '#999', fontSize: 12 }}>
        Gagal muat
      </span>
    );
  }
  if (!blobUrl) {
    return <Skeleton variant="rectangular" width={style?.width || 56} height={style?.height || 56} className={className} />;
  }

  const handleClick = (event) => {
    if (onClick) return onClick(event);
    if (enablePreview) {
      openInAppFilePreview({
        url: toProtectedFileUrl(src),
        title: previewTitle || alt || 'Preview',
      });
    }
  };

  return (
    <img
      src={blobUrl}
      alt={alt}
      className={className}
      style={{ cursor: enablePreview || onClick ? 'pointer' : style?.cursor, ...style }}
      onClick={handleClick}
      {...rest}
    />
  );
}
